import { 
    page,
    details
} from '@/api/integral.js'

export default {
  state: {
    list: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    integralLoading: false
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setIntegralLoading (state, loading) {
      state.integralLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    integralList: state => state.list,
    integralTotal: state => state.total,
    integralLoading: state => state.integralLoading
  },
  actions: {
    getIntegralRecordPage ({ state, commit }, param) {
      commit('setIntegralLoading', true)
      return new Promise((resolve, reject) => {
        page(param).then(res => {
          const data = res.data.result
          const list = data.records
          const total = data.total
          const pageNum = data.pageNum
          const pageSize = data.pageSize
          commit('setList', list)
          commit('setTotal', total)
          commit('setPageNum', pageNum)
          commit('setPageSize', pageSize)
          commit('setIntegralLoading', false)
          resolve()
        }).catch(err => {
          commit('setIntegralLoading', false)
          reject(err)
        })
      })
    },
    getIntegralItemRecordPage ({ state, commit }, param ) {
      return new Promise((resolve, reject) => {
        details(param).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/integral.js